// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles/common.module.css */

/* Center the card in the viewport with a light gray background */
.common_container__pLnuX {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: white;
  color: #000;
}

/* Card with white background, subtle shadow, and rounded corners */
.common_card__Wgp21 {
  background: rgb(12, 12, 12);
  padding: 2em;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 500px;
  box-sizing: border-box;
  justify-content: center;
}

/* Large bold title centered at the top */
.common_title__q-4bs,
.common_subtitle__oz\\+U- {
  font-size: 2em;
  font-weight: bold;
  margin-bottom: 1em;
  text-align: center;
  color: #fff;
}

.common_subtitle__oz\\+U- {
  font-size: 1.25em;
  margin-bottom: 1em;
  text-align: center;
}

/* Input fields: full width, white background, black text, subtle border */
.common_inputField__iqUmY {
  width: 100%;
  padding: 0.75em;
  font-size: 1em;
  margin-bottom: 1em;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
  background: #fff;
  color: #000;
}

/* Dropdown with similar styling to input fields if used */
.common_selectDropdown__AEFLW {
  width: 100%;
  padding: 0.75em;
  font-size: 1em;
  margin-bottom: 1em;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: #fff;
  color: #000;
  box-sizing: border-box;
}

/* Full-width button in blue */
.common_button__\\+5XEo {
  width: 100%;
  background: #0070f3;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 0.75em;
  font-size: 1em;
  cursor: pointer;
  transition: background 0.3s ease;
  margin-bottom: 1em;
  text-align: center;
}

.common_button__\\+5XEo:hover {
  background: #0059c9;
}

/* Links beneath the button, centered and simple text styling */
.common_link__DXont {
  color: #000;
  text-decoration: none;
  cursor: pointer;
  font-size: 0.9em;
  margin-top: 0.5em;
  text-align: center;
  display: block;
  /* ensures each link is on its own line */
}

.common_link__DXont:hover {
  text-decoration: underline;
}

.common_popupOverlay__vSbpu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Dark overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.common_popup__ftjYH {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 90%;
}

.common_popup__ftjYH h3 {
  margin-bottom: 15px;
  font-size: 18px;
  color: #333;
}

.common_popup__ftjYH p {
  margin-bottom: 20px;
  font-size: 14px;
  color: #555;
}

.common_popupButton__msgUR {
  padding: 10px 15px;
  font-size: 14px;
  background-color: #007bff;
  /* Bootstrap primary blue */
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.common_popupButton__msgUR:hover {
  background-color: #0056b3;
  /* Darker blue on hover */
}

/* Container styles for each scheme (read & edit mode) */
.common_securityContainer__SHHTu {
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  position: relative;
}

/* Common form control for inputs and selects */
.common_securityFormControl__L9baI {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

/* Cancel button style */
.common_securityCancelButton__EVyUZ {
  padding: 10px 15px;
  background-color: #ccc;
  color: black;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* Save button style */
.common_securitySaveButton__miZt1 {
  padding: 10px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.common_sNcButtonContainer__ujqfx {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}

/* Add Security button style */
.common_securityAddButton__Zn8Rp {
  width: 100%;
  padding: 10px;
  margin-top: 15px;
  font-size: 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
}

.common_securityAddButton__Zn8Rp.common_disabled__xcYRT {
  background-color: #ccc;
  cursor: not-allowed;
}

/* Buttons container at the top right of each scheme */
.common_securitySchemeButtons__0HjXd {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 10px;
}

/* Container for the new scheme form (without the position property) */
.common_securityNewSchemeContainer__nfF5y {
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
}

/* Edit and Delete button styles */
.common_securityEditButton__fa9Z0 {
  padding: 5px 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.common_securityDeleteButton__5Ml\\+c {
  padding: 5px 10px;
  background-color: red;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* Container for form buttons (Cancel/Save) */
.common_securityFormButtons__HQlVm {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  gap: 10px;
}

/* Scope field styles */
.common_securityScopeItem__ZNMiz {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.common_securityScopeName__-9SH6 {
  margin-right: 10px;
  font-weight: bold;
}

.common_securityScopeDesc__w35tA {
  margin-right: 10px;
}

/* Button for adding a new scope */
.common_securityAddScopeButton__M1jJ1 {
  margin-top: 10px;
  padding: 8px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.common_securityAddScopeButton__M1jJ1.common_disabled__xcYRT {
  background-color: #ccc;
  cursor: not-allowed;
}

/* Container for scope fields */
.common_securityScopeFields__S6Yw9 {
  margin-top: 10px;
}

/* Specific styles for the scope select and input fields */
.common_securityScopeSelect__voUxA {
  width: 50%;
  padding: 8px;
  margin-right: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.common_securityScopeInput__mxSYv {
  width: 50%;
  padding: 8px;
  margin-right: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

/* Button to add the scope field */
.common_securityAddScopeFieldButton__aF2Ap {
  padding: 8px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* Style for the “All scopes have been defined” text */
.common_securityAllScopesDefined__8qb8f {
  margin-top: 10px;
  font-style: italic;
  color: gray;
}

.common_securityErrorMessage__ZqDAG {
  color: red;
  font-size: 00.9em
}

.common_securityEditScope__VfScl {
  margin-left: 15px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.common_securityFlows__57QYn {
  margin-left: 15px;
}

.common_centeredHeading__MWHP8 {
  text-align: center;
  margin-top: 10px;
}

.common_pageWrapper__J7T0a {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.common_header__9NYsj {
  background-color: rgb(12, 12, 12);
  color: white;
  padding: 20px 40px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-bottom: 1px solid #333;
}

.common_footer__4O8Er {
  background-color: rgb(12, 12, 12);
  color: #555;
  text-align: center;
  padding: 15px;
  margin-top: auto;
  font-size: 14px;
  border-top: 1px solid #333;
}

.common_nav__0vgWn {
  display: flex;
  gap: 15px;
}

.common_nav__0vgWn button {
  background: none;
  border: none;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  padding: 5px 10px;
}

.common_nav__0vgWn button:hover {
  text-decoration: underline;
}

.common_footerNav__s4kFe {
  margin-bottom: 10px;
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

.common_footerNav__s4kFe button {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  padding: 5px 10px;
}

.common_footerNav__s4kFe button:hover {
  text-decoration: underline;
}

.common_imageContainer__ng3wg {
  flex: 1 1;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(12, 12, 12);
  overflow: hidden;
}

.common_homeImage__yJ5eO {
  position: absolute;
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
  object-fit: contain;
  max-height: 100%;
  z-index: 1;
}

.common_overlayContent__Be8lt {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 20px;
}

.common_textWrapper__GCbCl {
  max-width: 708px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: center;
}

.common_heroHeading__YV6T1 {
  font-size: 4rem;
  font-weight: 600;
  color: white;
}

.common_violet__H1Vtu {
  color: violet;
}

.common_blue__ywh1K {
  color: #00f;
}

.common_heroSubtext__iVJqD {
  color: #ccc;
  font-size: 1rem;
  font-weight: 500;
  max-width: 90%;
  margin: 0 auto;
}

.common_buttonWrapper__ZPTky {
  display: flex;
  justify-content: center;
}

.common_homeButtonGroup__wy\\+4k {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.common_startButton__TTgn1 {
  padding: 0.5rem 1rem;
  cursor: pointer;
  color: var(--primary-white);
  font-weight: 600;
  background-color: var(--color-primary-blue);
  border: 2px solid var(--color-text-blue);
  border-radius: 9999px;
}

.common_demoButton__RXjBy {
  padding: 0.5rem 1rem;
  cursor: pointer;
  color: var(--primary-white);
  background-color: var(--color--primary-black);
  font-weight: 600;
  border: 1px solid var(--color-secondary-gray);
  border-radius: 9999px;
}

.common_loginPageWrapper__BMBke {
  display: flex;
  height: 100vh;
  width: 100%;
}

.common_leftPane__7BT\\+f {
  flex: 1 1;
  background-color: rgb(12, 12, 12);
  display: flex;
  align-items: center;
  justify-content: center;
}

.common_rightPane__ucavl {
  flex: 1 1;
  background-size: cover;
  background-position: center;
  position: relative;
  color: blueviolet;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom;
  background-color: rgb(12, 12, 12);
}

.common_loginOverlayContent__EES96 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 2rem;
  display: flex;
  flex-direction: column;
}

.common_loginOverlayHeading__jxLql {
  font-size: 4rem;
  font-weight: bold;
}

.common_loginOverlaySubtext__wYM3Q {
  font-size: 1rem;
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
  color: white;
}

.common_loginForm__QP3OL {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 80%;
  max-width: 400px;
}

.common_dashboardWrap__7V--Y {
  width: 100%;
  min-height: 100vh;
  position: relative;
}

.common_dashboardBody__xhKM8 {
  background-color: #0c0c0c;
  height: 90vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.common_dashboardContent__zRHLI {
  display: flex;
  max-width: 945px;
  gap: 4rem;
  margin: 0 auto;
  position: relative;
  z-index: 2;
  justify-content: center;
  flex-wrap: nowrap;
}

.common_dashboardCard__IZsAj {
  width: 210px;
  height: 250px;
  margin: 0 auto;
  padding: 0.25rem;
  border-radius: 1rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid transparent;
  transition: border 0.3s ease-in;
}

.common_dashboardCard__IZsAj:hover {
  border-color: #ffffff;
}

.common_bgDefine__dkiPe {
  background-color: #133D4E;
}

.common_bgAssets__aPh86 {
  background-color: #22370D;
}

.common_bgExplore__ZdZ43 {
  background-color: #35258E;
}

.common_bgImport__S\\+L8k {
  background-color: #38014B;
}

.common_cardLink__9GiLL {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  text-decoration: none;
  color: inherit;
}

.common_imageWrapper__3vTpN {
  padding: 20px;
  width: 8rem;
  margin: 0 auto;
}

.common_image__vZKPc {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.common_cardFooter__KiZiV {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.25rem;
  padding-right: 0.25rem;
}

.common_cardTitle__y2rsw {
  color: #ffffff;
  padding: 10px;
  margin-left: 1.5rem;
  font-size: 1.25rem;
  font-weight: 500;
}

.common_arrowBlock__4xe2j {
  width: 3rem;
  height: 3rem;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 9999px;
  transition: transform 0.3s ease-in;
}

.common_dashboardCard__IZsAj:hover .common_arrowBlock__4xe2j img {
  transform: rotate(37deg);
}

.common_bottomPattern__Y-0Pi {
  height: 20vh;
  width: 100vw;
  position: absolute;
  bottom: 0;
  left: 0;
  overflow: hidden;
  z-index: 0;
}

.common_bottomPattern__Y-0Pi img {
  width: 100%;
  height: auto;
  display: block;
}


.common_footerNote__OcWIQ {
  position: absolute;
  bottom: 1.75rem;
  text-align: center;
  width: 100%;
  color: #A7A7A7;
  font-size: 0.875rem;
  font-weight: 500;
}

.common_sectionHeadings__w\\+Nmp {
  font-size: 1.25rem;
  font-weight: 600;
  color: black; 
  margin-bottom: 1rem;
  text-transform: uppercase; 
}

.common_welcomeBanner__6Th99 {
  color: white;
  font-size: 2.25rem;
  padding-bottom: 25px;
}`, "",{"version":3,"sources":["webpack://./src/common.module.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B,iEAAiE;AACjE;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA,mEAAmE;AACnE;EACE,2BAA2B;EAC3B,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,yCAAyC;AACzC;;EAEE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,0EAA0E;AAC1E;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA,sEAAsE;AACtE;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;AAClB;;AAEA,0DAA0D;AAC1D;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sDAAsD;AACtD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;EACV;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,2CAA2C;EAC3C,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,6CAA6C;EAC7C,gBAAgB;EAChB,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;;AAGA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB","sourcesContent":["/* styles/common.module.css */\n\n/* Center the card in the viewport with a light gray background */\n.container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: white;\n  color: #000;\n}\n\n/* Card with white background, subtle shadow, and rounded corners */\n.card {\n  background: rgb(12, 12, 12);\n  padding: 2em;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 500px;\n  box-sizing: border-box;\n  justify-content: center;\n}\n\n/* Large bold title centered at the top */\n.title,\n.subtitle {\n  font-size: 2em;\n  font-weight: bold;\n  margin-bottom: 1em;\n  text-align: center;\n  color: #fff;\n}\n\n.subtitle {\n  font-size: 1.25em;\n  margin-bottom: 1em;\n  text-align: center;\n}\n\n/* Input fields: full width, white background, black text, subtle border */\n.inputField {\n  width: 100%;\n  padding: 0.75em;\n  font-size: 1em;\n  margin-bottom: 1em;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-sizing: border-box;\n  background: #fff;\n  color: #000;\n}\n\n/* Dropdown with similar styling to input fields if used */\n.selectDropdown {\n  width: 100%;\n  padding: 0.75em;\n  font-size: 1em;\n  margin-bottom: 1em;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background: #fff;\n  color: #000;\n  box-sizing: border-box;\n}\n\n/* Full-width button in blue */\n.button {\n  width: 100%;\n  background: #0070f3;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  padding: 0.75em;\n  font-size: 1em;\n  cursor: pointer;\n  transition: background 0.3s ease;\n  margin-bottom: 1em;\n  text-align: center;\n}\n\n.button:hover {\n  background: #0059c9;\n}\n\n/* Links beneath the button, centered and simple text styling */\n.link {\n  color: #000;\n  text-decoration: none;\n  cursor: pointer;\n  font-size: 0.9em;\n  margin-top: 0.5em;\n  text-align: center;\n  display: block;\n  /* ensures each link is on its own line */\n}\n\n.link:hover {\n  text-decoration: underline;\n}\n\n.popupOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  /* Dark overlay */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.popup {\n  background-color: white;\n  padding: 20px;\n  border-radius: 10px;\n  text-align: center;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  max-width: 400px;\n  width: 90%;\n}\n\n.popup h3 {\n  margin-bottom: 15px;\n  font-size: 18px;\n  color: #333;\n}\n\n.popup p {\n  margin-bottom: 20px;\n  font-size: 14px;\n  color: #555;\n}\n\n.popupButton {\n  padding: 10px 15px;\n  font-size: 14px;\n  background-color: #007bff;\n  /* Bootstrap primary blue */\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.popupButton:hover {\n  background-color: #0056b3;\n  /* Darker blue on hover */\n}\n\n/* Container styles for each scheme (read & edit mode) */\n.securityContainer {\n  border: 1px solid #ccc;\n  padding: 10px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n  position: relative;\n}\n\n/* Common form control for inputs and selects */\n.securityFormControl {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 10px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n}\n\n/* Cancel button style */\n.securityCancelButton {\n  padding: 10px 15px;\n  background-color: #ccc;\n  color: black;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n/* Save button style */\n.securitySaveButton {\n  padding: 10px 15px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.sNcButtonContainer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n/* Add Security button style */\n.securityAddButton {\n  width: 100%;\n  padding: 10px;\n  margin-top: 15px;\n  font-size: 16px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n}\n\n.securityAddButton.disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n/* Buttons container at the top right of each scheme */\n.securitySchemeButtons {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: flex;\n  gap: 10px;\n}\n\n/* Container for the new scheme form (without the position property) */\n.securityNewSchemeContainer {\n  border: 1px solid #ccc;\n  padding: 10px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n/* Edit and Delete button styles */\n.securityEditButton {\n  padding: 5px 10px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.securityDeleteButton {\n  padding: 5px 10px;\n  background-color: red;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n/* Container for form buttons (Cancel/Save) */\n.securityFormButtons {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 10px;\n  gap: 10px;\n}\n\n/* Scope field styles */\n.securityScopeItem {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.securityScopeName {\n  margin-right: 10px;\n  font-weight: bold;\n}\n\n.securityScopeDesc {\n  margin-right: 10px;\n}\n\n/* Button for adding a new scope */\n.securityAddScopeButton {\n  margin-top: 10px;\n  padding: 8px 15px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.securityAddScopeButton.disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n/* Container for scope fields */\n.securityScopeFields {\n  margin-top: 10px;\n}\n\n/* Specific styles for the scope select and input fields */\n.securityScopeSelect {\n  width: 50%;\n  padding: 8px;\n  margin-right: 10px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n\n.securityScopeInput {\n  width: 50%;\n  padding: 8px;\n  margin-right: 10px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n\n/* Button to add the scope field */\n.securityAddScopeFieldButton {\n  padding: 8px 15px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n/* Style for the “All scopes have been defined” text */\n.securityAllScopesDefined {\n  margin-top: 10px;\n  font-style: italic;\n  color: gray;\n}\n\n.securityErrorMessage {\n  color: red;\n  font-size: 00.9em\n}\n\n.securityEditScope {\n  margin-left: 15px;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n}\n\n.securityFlows {\n  margin-left: 15px;\n}\n\n.centeredHeading {\n  text-align: center;\n  margin-top: 10px;\n}\n\n.pageWrapper {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.header {\n  background-color: rgb(12, 12, 12);\n  color: white;\n  padding: 20px 40px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  border-bottom: 1px solid #333;\n}\n\n.footer {\n  background-color: rgb(12, 12, 12);\n  color: #555;\n  text-align: center;\n  padding: 15px;\n  margin-top: auto;\n  font-size: 14px;\n  border-top: 1px solid #333;\n}\n\n.nav {\n  display: flex;\n  gap: 15px;\n}\n\n.nav button {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 1rem;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n\n.nav button:hover {\n  text-decoration: underline;\n}\n\n.footerNav {\n  margin-bottom: 10px;\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.footerNav button {\n  background: none;\n  border: none;\n  color: #007bff;\n  cursor: pointer;\n  padding: 5px 10px;\n}\n\n.footerNav button:hover {\n  text-decoration: underline;\n}\n\n.imageContainer {\n  flex: 1;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: rgb(12, 12, 12);\n  overflow: hidden;\n}\n\n.homeImage {\n  position: absolute;\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16 / 9;\n  object-fit: contain;\n  max-height: 100%;\n  z-index: 1;\n}\n\n.overlayContent {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n}\n\n.textWrapper {\n  max-width: 708px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  text-align: center;\n}\n\n.heroHeading {\n  font-size: 4rem;\n  font-weight: 600;\n  color: white;\n}\n\n.violet {\n  color: violet;\n}\n\n.blue {\n  color: #00f;\n}\n\n.heroSubtext {\n  color: #ccc;\n  font-size: 1rem;\n  font-weight: 500;\n  max-width: 90%;\n  margin: 0 auto;\n}\n\n.buttonWrapper {\n  display: flex;\n  justify-content: center;\n}\n\n.homeButtonGroup {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n}\n\n.startButton {\n  padding: 0.5rem 1rem;\n  cursor: pointer;\n  color: var(--primary-white);\n  font-weight: 600;\n  background-color: var(--color-primary-blue);\n  border: 2px solid var(--color-text-blue);\n  border-radius: 9999px;\n}\n\n.demoButton {\n  padding: 0.5rem 1rem;\n  cursor: pointer;\n  color: var(--primary-white);\n  background-color: var(--color--primary-black);\n  font-weight: 600;\n  border: 1px solid var(--color-secondary-gray);\n  border-radius: 9999px;\n}\n\n.loginPageWrapper {\n  display: flex;\n  height: 100vh;\n  width: 100%;\n}\n\n.leftPane {\n  flex: 1;\n  background-color: rgb(12, 12, 12);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.rightPane {\n  flex: 1;\n  background-size: cover;\n  background-position: center;\n  position: relative;\n  color: blueviolet;\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: bottom;\n  background-color: rgb(12, 12, 12);\n}\n\n.loginOverlayContent {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.loginOverlayHeading {\n  font-size: 4rem;\n  font-weight: bold;\n}\n\n.loginOverlaySubtext {\n  font-size: 1rem;\n  max-width: 80%;\n  margin-left: auto;\n  margin-right: auto;\n  line-height: 1.5;\n  color: white;\n}\n\n.loginForm {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: 80%;\n  max-width: 400px;\n}\n\n.dashboardWrap {\n  width: 100%;\n  min-height: 100vh;\n  position: relative;\n}\n\n.dashboardBody {\n  background-color: #0c0c0c;\n  height: 90vh;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.dashboardContent {\n  display: flex;\n  max-width: 945px;\n  gap: 4rem;\n  margin: 0 auto;\n  position: relative;\n  z-index: 2;\n  justify-content: center;\n  flex-wrap: nowrap;\n}\n\n.dashboardCard {\n  width: 210px;\n  height: 250px;\n  margin: 0 auto;\n  padding: 0.25rem;\n  border-radius: 1rem;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  border: 1px solid transparent;\n  transition: border 0.3s ease-in;\n}\n\n.dashboardCard:hover {\n  border-color: #ffffff;\n}\n\n.bgDefine {\n  background-color: #133D4E;\n}\n\n.bgAssets {\n  background-color: #22370D;\n}\n\n.bgExplore {\n  background-color: #35258E;\n}\n\n.bgImport {\n  background-color: #38014B;\n}\n\n.cardLink {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  text-decoration: none;\n  color: inherit;\n}\n\n.imageWrapper {\n  padding: 20px;\n  width: 8rem;\n  margin: 0 auto;\n}\n\n.image {\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n.cardFooter {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 0.25rem;\n  padding-right: 0.25rem;\n}\n\n.cardTitle {\n  color: #ffffff;\n  padding: 10px;\n  margin-left: 1.5rem;\n  font-size: 1.25rem;\n  font-weight: 500;\n}\n\n.arrowBlock {\n  width: 3rem;\n  height: 3rem;\n  background-color: #ffffff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 9999px;\n  transition: transform 0.3s ease-in;\n}\n\n.dashboardCard:hover .arrowBlock img {\n  transform: rotate(37deg);\n}\n\n.bottomPattern {\n  height: 20vh;\n  width: 100vw;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  overflow: hidden;\n  z-index: 0;\n}\n\n.bottomPattern img {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n\n.footerNote {\n  position: absolute;\n  bottom: 1.75rem;\n  text-align: center;\n  width: 100%;\n  color: #A7A7A7;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.sectionHeadings {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: black; \n  margin-bottom: 1rem;\n  text-transform: uppercase; \n}\n\n.welcomeBanner {\n  color: white;\n  font-size: 2.25rem;\n  padding-bottom: 25px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `common_container__pLnuX`,
	"card": `common_card__Wgp21`,
	"title": `common_title__q-4bs`,
	"subtitle": `common_subtitle__oz+U-`,
	"inputField": `common_inputField__iqUmY`,
	"selectDropdown": `common_selectDropdown__AEFLW`,
	"button": `common_button__+5XEo`,
	"link": `common_link__DXont`,
	"popupOverlay": `common_popupOverlay__vSbpu`,
	"popup": `common_popup__ftjYH`,
	"popupButton": `common_popupButton__msgUR`,
	"securityContainer": `common_securityContainer__SHHTu`,
	"securityFormControl": `common_securityFormControl__L9baI`,
	"securityCancelButton": `common_securityCancelButton__EVyUZ`,
	"securitySaveButton": `common_securitySaveButton__miZt1`,
	"sNcButtonContainer": `common_sNcButtonContainer__ujqfx`,
	"securityAddButton": `common_securityAddButton__Zn8Rp`,
	"disabled": `common_disabled__xcYRT`,
	"securitySchemeButtons": `common_securitySchemeButtons__0HjXd`,
	"securityNewSchemeContainer": `common_securityNewSchemeContainer__nfF5y`,
	"securityEditButton": `common_securityEditButton__fa9Z0`,
	"securityDeleteButton": `common_securityDeleteButton__5Ml+c`,
	"securityFormButtons": `common_securityFormButtons__HQlVm`,
	"securityScopeItem": `common_securityScopeItem__ZNMiz`,
	"securityScopeName": `common_securityScopeName__-9SH6`,
	"securityScopeDesc": `common_securityScopeDesc__w35tA`,
	"securityAddScopeButton": `common_securityAddScopeButton__M1jJ1`,
	"securityScopeFields": `common_securityScopeFields__S6Yw9`,
	"securityScopeSelect": `common_securityScopeSelect__voUxA`,
	"securityScopeInput": `common_securityScopeInput__mxSYv`,
	"securityAddScopeFieldButton": `common_securityAddScopeFieldButton__aF2Ap`,
	"securityAllScopesDefined": `common_securityAllScopesDefined__8qb8f`,
	"securityErrorMessage": `common_securityErrorMessage__ZqDAG`,
	"securityEditScope": `common_securityEditScope__VfScl`,
	"securityFlows": `common_securityFlows__57QYn`,
	"centeredHeading": `common_centeredHeading__MWHP8`,
	"pageWrapper": `common_pageWrapper__J7T0a`,
	"header": `common_header__9NYsj`,
	"footer": `common_footer__4O8Er`,
	"nav": `common_nav__0vgWn`,
	"footerNav": `common_footerNav__s4kFe`,
	"imageContainer": `common_imageContainer__ng3wg`,
	"homeImage": `common_homeImage__yJ5eO`,
	"overlayContent": `common_overlayContent__Be8lt`,
	"textWrapper": `common_textWrapper__GCbCl`,
	"heroHeading": `common_heroHeading__YV6T1`,
	"violet": `common_violet__H1Vtu`,
	"blue": `common_blue__ywh1K`,
	"heroSubtext": `common_heroSubtext__iVJqD`,
	"buttonWrapper": `common_buttonWrapper__ZPTky`,
	"homeButtonGroup": `common_homeButtonGroup__wy+4k`,
	"startButton": `common_startButton__TTgn1`,
	"demoButton": `common_demoButton__RXjBy`,
	"loginPageWrapper": `common_loginPageWrapper__BMBke`,
	"leftPane": `common_leftPane__7BT+f`,
	"rightPane": `common_rightPane__ucavl`,
	"loginOverlayContent": `common_loginOverlayContent__EES96`,
	"loginOverlayHeading": `common_loginOverlayHeading__jxLql`,
	"loginOverlaySubtext": `common_loginOverlaySubtext__wYM3Q`,
	"loginForm": `common_loginForm__QP3OL`,
	"dashboardWrap": `common_dashboardWrap__7V--Y`,
	"dashboardBody": `common_dashboardBody__xhKM8`,
	"dashboardContent": `common_dashboardContent__zRHLI`,
	"dashboardCard": `common_dashboardCard__IZsAj`,
	"bgDefine": `common_bgDefine__dkiPe`,
	"bgAssets": `common_bgAssets__aPh86`,
	"bgExplore": `common_bgExplore__ZdZ43`,
	"bgImport": `common_bgImport__S+L8k`,
	"cardLink": `common_cardLink__9GiLL`,
	"imageWrapper": `common_imageWrapper__3vTpN`,
	"image": `common_image__vZKPc`,
	"cardFooter": `common_cardFooter__KiZiV`,
	"cardTitle": `common_cardTitle__y2rsw`,
	"arrowBlock": `common_arrowBlock__4xe2j`,
	"bottomPattern": `common_bottomPattern__Y-0Pi`,
	"footerNote": `common_footerNote__OcWIQ`,
	"sectionHeadings": `common_sectionHeadings__w+Nmp`,
	"welcomeBanner": `common_welcomeBanner__6Th99`
};
export default ___CSS_LOADER_EXPORT___;
